import { Database, Q } from '@nozbe/watermelondb'
import { ComponentInfoChatVO } from '@repo/types'
import { Chat } from '../model'

const buildMatchClause = (payload: ComponentInfoChatVO[]) =>
  Q.or(
    ...payload.map(chat =>
      Q.and(Q.where('connection_key', chat.connectionKey), Q.where('phone_number', chat.phoneNumber))
    )
  )

export const addChatsInBatch = async (payload: ComponentInfoChatVO[], database: Database): Promise<void> => {
  if (!payload.length) return

  try {
    await database.write(async writer => {
      const chatsCollection = database.get<Chat>('chats')
      const existing = await chatsCollection.query(buildMatchClause(payload)).fetch()
      const byKey = new Map(existing.map(chat => [`${chat.connectionKey}|${chat.phoneNumber}`, chat]))

      const chatsToUpdate = payload.map(chatVO => {
        const uniqueKey = `${chatVO.connectionKey}|${chatVO.phoneNumber}`
        const foundChat = byKey.get(uniqueKey)

        if (foundChat) {
          return foundChat.prepareUpdateChat(chatVO)
        } else {
          return chatsCollection.prepareCreate(chat => chat.setChatByComponentInfoChatVO(chatVO))
        }
      })

      await writer.batch(...chatsToUpdate)
    })
  } catch (e) {
    console.error(e)
  }
}
